import { useCallback, useState, useEffect } from 'react';
import { useDownloadStateStore } from '@annunciate/core';
import { useDownloadProgress, } from '@annunciate/core';
import { useDownloadCancelOrDeleteMutation, useDownloadCreateMutation, useDownloadQuery, } from '../query';
const { getTasksForContentId } = useDownloadStateStore.getState();
export const useDownloader = (content) => {
    const [isDownloaded, setIsDownloaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const progress = useDownloadProgress(content.id);
    const { data: download } = useDownloadQuery(content);
    useEffect(() => {
        if (content && download && content.id === download.id) {
            const tasks = getTasksForContentId(content.id.toString());
            setIsDownloaded((tasks.length === 0 && download) ||
                (tasks.length > 0 &&
                    progress !== undefined &&
                    progress === 1));
        }
        else {
            setIsDownloaded(false);
        }
    }, [
        progress,
        content?.id,
        download?.id,
    ]);
    const { isError: isDeletingError, isPending: isDeleting, mutateAsync: cancelOrDeleteMutate, } = useDownloadCancelOrDeleteMutation();
    const { isError: isDownloadError, isPending: isCreateMutationLoading, mutateAsync: createMutate, reset: resetDownloadCreate, } = useDownloadCreateMutation();
    const isDownloading = !download
        ? false
        : isCreateMutationLoading || (progress < 1 && progress > 0);
    const onToggleDownload = useCallback(async () => {
        if (isLoading !== (isDeleting || isDownloading)) {
            setIsLoading(isDeleting || isDownloading);
        }
        if (isDeleting || isDownloading)
            return;
        if (isDownloaded) {
            await cancelOrDeleteMutate(content);
        }
        else {
            await createMutate(content);
        }
    }, [
        content?.id,
        isLoading,
        isDownloaded,
        isDeletingError,
        isDeleting,
        isDownloadError,
        isDownloading,
    ]);
    return {
        onToggleDownload,
        isDownloaded,
        isDownloading,
        isDownloadError,
        isDeleting,
        isDeletingError,
        isLoading,
        progress,
        cancelOrDelete: () => {
            cancelOrDeleteMutate(content);
            resetDownloadCreate();
        },
    };
};
//# sourceMappingURL=useDownloader.js.map